import { render, staticRenderFns } from "./CardGroupEditor.vue?vue&type=template&id=4ff41037&"
import script from "./CardGroupEditor.vue?vue&type=script&lang=js&"
export * from "./CardGroupEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports